import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../../ui';

const BackButton = ({ onClick, label = 'Volver' }) => {
  return (
    <div className="col-12 mb-3 mt-2">
      <div className="d-flex justify-content-start">
        <Button variant="link" onClick={onClick}>
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          {label}
        </Button>
      </div>
    </div>
  );
};

export default BackButton;
